import React from "react";
import { RadioProps } from "@chakra-ui/react";
import { StyledRadio } from "./Radio.styled";

export const Radio: React.FC<RadioProps> = ({ children, ...props }) => {
  return <StyledRadio {...props}>{children}</StyledRadio>;
};
